/* Libraries */
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import qs from 'qs';

/* Hooks */
import { useLayoutContext } from '~/src/contexts/Layout';
import { useDraftingAgentEnabled } from '~/src/entities/user/hooks/useFeatureAccess';

/* Components */
import Page from '~/src/components/PageLayout/Page';
import TemplateSetDraftContainer from '~/src/containers/TemplateSetDraft';
import TemplateSetupContainer from '~/src/containers/TemplateSetupContainer';
import TemplateSetupPreviewContainer from '~/src/containers/TemplateSetupPreviewContainer';
import { AiGemIcon } from '~/src/components/icons';

const TemplateRoutes = () => {
  const { setTitle } = useLayoutContext();

  const isDraftingAgentEnabled = useDraftingAgentEnabled();

  return (
    <Switch>
      {isDraftingAgentEnabled && (
        <Route
          exact
          path="/templates/setup"
          render={() => {
            return (
              <Page
                disablePadding={true}
                title={
                  <>
                    <AiGemIcon width={20} height={20} />
                    Create templates from documents
                  </>
                }
              >
                <TemplateSetupContainer />
              </Page>
            );
          }}
        />
      )}

      {isDraftingAgentEnabled && (
        <Route
          exact
          path="/templates/setup/:taskId"
          render={(props) => {
            setTitle('Template Preview');

            const { taskId } = props.match.params;

            return (
              <Page>
                <TemplateSetupPreviewContainer taskId={parseInt(taskId)} />
              </Page>
            );
          }}
        />
      )}
      <Route
        exact
        path="/templates/docset/new"
        render={({ location }) => {
          const { ids = [], title } = qs.parse(location.search, {
            ignoreQueryPrefix: true,
          });

          setTitle('Draft new document set');

          return (
            <Page>
              <TemplateSetDraftContainer templateIds={ids} title={title} />
            </Page>
          );
        }}
      />
      <Route
        exact
        path="/templates/:templateId/new"
        render={({ match: { params } }) => {
          setTitle('Draft new document');

          return (
            <Page>
              <TemplateSetDraftContainer templateIds={[params.templateId]} />
            </Page>
          );
        }}
      />
      <Redirect to={'/library'} />
    </Switch>
  );
};

export default TemplateRoutes;
